// extracted by mini-css-extract-plugin
export default {"main":"RecoveryEmail_main__sHD1s","errorsMessages":"RecoveryEmail_errorsMessages__tuaOs"};